import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <br />
    <h2>{`📈 Achievements`}</h2>
    <br />
    <br />
    <h4>{`🎯 Jagadis Chandra Bose National Science Talent Search Bigyani Kanya Medha Britti 2018 Scholarship Awardee.`}</h4>
    <h5>{`Annual Scholarship and Book Grant from State Govt WB`}</h5>
    <br />
    <h4>{`🎯  Olympiad rank 1 and AIR 1 in IOM 2011, organised by SilverZone, India`}</h4>
    <h5>{`Merit Certificate and cash prize from SilverZone.`}</h5>
    <br />
    <h4>{`🎯 NPTEL - Programming, Data structures, Algorithms using Python Silver Elite Certificate from NPTEL.`}</h4>
    <h5>{`Percentage Score - 80 %`}</h5>
    <br />
    <h4>{`🎯 NPTEL - Problem Solving Through Programming in C Silver Elite Certificate from NPTEL.`}</h4>
    <h5>{`Percentage Score - 84% (Top 2%)`}</h5>
    <br />
    <h4>{`🎯 Udacity Deep Learning Nano degree Scholarship recipient 2019 powered by Bertelsmann (Track2)`}</h4>
    <br />
    <h4>{`🎯 Facebook Developer Circles Scholarship recipient on Data Science Training Course 2019 (Track2)`}</h4>
    <br />
    <h4>{`🎯 Completed 30 days of Google Cloud program`}</h4>
    <br />
    <h4>{`🎯 IBM Blochchain Essentials V2 Percentage Score - 90% Badge of completing the course from IBM.`}</h4>
    <br />
    <h4>{`🎯 Top performer of college semester exam`}</h4>
    <br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      